"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const SearchContext = react_1.createContext({});
SearchContext.displayName = 'SearchContext';
exports.default = SearchContext;
